/**
 * Mahjong Notation Parser and Renderer
 * Renders Riichi Mahjong hands from standard notation (MPSZ) into SVGs
 */

const TILE_MAP = {
    // Characters (Man)
    "1m": { file: "Man1.svg", name: "1 Man" },
    "2m": { file: "Man2.svg", name: "2 Man" },
    "3m": { file: "Man3.svg", name: "3 Man" },
    "4m": { file: "Man4.svg", name: "4 Man" },
    "5m": { file: "Man5.svg", name: "5 Man" },
    "0m": { file: "Man5-Dora.svg", name: "Red 5 Man", isDora: true },
    "5mr": { file: "Man5-Dora.svg", name: "Red 5 Man", isDora: true },
    "r5m": { file: "Man5-Dora.svg", name: "Red 5 Man", isDora: true },
    "6m": { file: "Man6.svg", name: "6 Man" },
    "7m": { file: "Man7.svg", name: "7 Man" },
    "8m": { file: "Man8.svg", name: "8 Man" },
    "9m": { file: "Man9.svg", name: "9 Man" },

    // Circles / Dots (Pin)
    "1p": { file: "Pin1.svg", name: "1 Pin" },
    "2p": { file: "Pin2.svg", name: "2 Pin" },
    "3p": { file: "Pin3.svg", name: "3 Pin" },
    "4p": { file: "Pin4.svg", name: "4 Pin" },
    "5p": { file: "Pin5.svg", name: "5 Pin" },
    "0p": { file: "Pin5-Dora.svg", name: "Red 5 Pin", isDora: true },
    "5pr": { file: "Pin5-Dora.svg", name: "Red 5 Pin", isDora: true },
    "r5p": { file: "Pin5-Dora.svg", name: "Red 5 Pin", isDora: true },
    "6p": { file: "Pin6.svg", name: "6 Pin" },
    "7p": { file: "Pin7.svg", name: "7 Pin" },
    "8p": { file: "Pin8.svg", name: "8 Pin" },
    "9p": { file: "Pin9.svg", name: "9 Pin" },

    // Bamboo (Sou)
    "1s": { file: "Sou1.svg", name: "1 Sou" },
    "2s": { file: "Sou2.svg", name: "2 Sou" },
    "3s": { file: "Sou3.svg", name: "3 Sou" },
    "4s": { file: "Sou4.svg", name: "4 Sou" },
    "5s": { file: "Sou5.svg", name: "5 Sou" },
    "0s": { file: "Sou5-Dora.svg", name: "Red 5 Sou", isDora: true },
    "5sr": { file: "Sou5-Dora.svg", name: "Red 5 Sou", isDora: true },
    "r5s": { file: "Sou5-Dora.svg", name: "Red 5 Sou", isDora: true },
    "6s": { file: "Sou6.svg", name: "6 Sou" },
    "7s": { file: "Sou7.svg", name: "7 Sou" },
    "8s": { file: "Sou8.svg", name: "8 Sou" },
    "9s": { file: "Sou9.svg", name: "9 Sou" },

    // Honors (Ji)
    "1z": { file: "Ton.svg", name: "East (Ton)" },
    "2z": { file: "Nan.svg", name: "South (Nan)" },
    "3z": { file: "Shaa.svg", name: "West (Shaa)" },
    "4z": { file: "Pei.svg", name: "North (Pei)" },
    "5z": { file: "Haku.svg", name: "White Dragon (Haku)" },
    "6z": { file: "Hatsu.svg", name: "Green Dragon (Hatsu)" },
    "7z": { file: "Chun.svg", name: "Red Dragon (Chun)" },

    // Aliases
    "ton": { file: "Ton.svg", name: "East (Ton)" },
    "nan": { file: "Nan.svg", name: "South (Nan)" },
    "shaa": { file: "Shaa.svg", name: "West (Shaa)" },
    "pei": { file: "Pei.svg", name: "North (Pei)" },
    "haku": { file: "Haku.svg", name: "White Dragon (Haku)" },
    "hatsu": { file: "Hatsu.svg", name: "Green Dragon (Hatsu)" },
    "chun": { file: "Chun.svg", name: "Red Dragon (Chun)" },
    "east": { file: "Ton.svg", name: "East (Ton)" },
    "south": { file: "Nan.svg", name: "South (Nan)" },
    "west": { file: "Shaa.svg", name: "West (Shaa)" },
    "north": { file: "Pei.svg", name: "North (Pei)" },
    "white": { file: "Haku.svg", name: "White Dragon (Haku)" },
    "green": { file: "Hatsu.svg", name: "Green Dragon (Hatsu)" },
    "red": { file: "Chun.svg", name: "Red Dragon (Chun)" },
};

const TENBOU_MAP = {
    "100": { file: "100.svg", name: "100 Points Tenbou" },
    "500": { file: "500.svg", name: "500 Points Tenbou" },
    "1000": { file: "1000.svg", name: "1,000 Points Riichi Stick" },
    "5000": { file: "5000.svg", name: "5,000 Points Tenbou" },
    "10000": { file: "10000.svg", name: "10,000 Points Tenbou" },
    "100pt": { file: "100.svg", name: "100 Points Tenbou" },
    "500pt": { file: "500.svg", name: "500 Points Tenbou" },
    "1000pt": { file: "1000.svg", name: "1,000 Points Riichi Stick" },
    "5000pt": { file: "5000.svg", name: "5,000 Points Tenbou" },
    "10000pt": { file: "10000.svg", name: "10,000 Points Tenbou" },
    "1k": { file: "1000.svg", name: "1,000 Points Riichi Stick" },
    "5k": { file: "5000.svg", name: "5,000 Points Tenbou" },
    "10k": { file: "10000.svg", name: "10,000 Points Tenbou" },
    "riichi": { file: "1000.svg", name: "1,000 Points Riichi Stick" },
};

/**
 * Determine base path for tile SVG assets
 */
export function getTilesBasePath(bordered = false) {
    let basePath = "";
    if (typeof window !== "undefined" && window.MAHJONG_TILES_PATH) {
        basePath = window.MAHJONG_TILES_PATH.replace(/\/+$/, "") + "/";
    } else if (typeof document !== "undefined") {
        const meta = document.querySelector('meta[name="mahjong-tiles-path"]');
        if (meta && meta.content) {
            basePath = meta.content.replace(/\/+$/, "") + "/";
        } else {
            // Dynamically derive from active theme script or link
            const script = document.querySelector('script[src*="built/index.js"]');
            if (script && script.src) {
                const srcUrl = new URL(script.src, window.location.href);
                basePath = srcUrl.href.replace(/\/built\/index\.js(\?.*)?$/, "/images/tiles/riichi_default/");
            } else {
                const link = document.querySelector('link[href*="built/index.css"]');
                if (link && link.href) {
                    const hrefUrl = new URL(link.href, window.location.href);
                    basePath = hrefUrl.href.replace(/\/built\/index\.css(\?.*)?$/, "/images/tiles/riichi_default/");
                } else {
                    basePath = "/assets/images/tiles/riichi_default/";
                }
            }
        }
    } else {
        basePath = "/assets/images/tiles/riichi_default/";
    }

    if (bordered && !basePath.endsWith("bordered/")) {
        basePath = basePath.replace(/\/+$/, "") + "/bordered/";
    }

    return basePath;
}

/**
 * Determine base path for tenbou SVG assets
 */
export function getTenbouBasePath() {
    if (typeof window !== "undefined" && window.MAHJONG_TENBOU_PATH) {
        return window.MAHJONG_TENBOU_PATH.replace(/\/+$/, "") + "/";
    }
    const tilesPath = getTilesBasePath(false);
    return tilesPath.replace(/\/tiles\/riichi_default\/?$/, "/tenbou/white/bordered/");
}

/**
 * Parse a group of tile notations (e.g. "123m", "456p", "0s", "1122z", "?", "r5m")
 * Returns array of tile objects
 */
export function parseTileGroup(groupStr) {
    if (!groupStr || !groupStr.trim()) return [];

    const str = groupStr.trim();
    const tiles = [];

    // Check if it's a point stick
    const tenbouKey = str.toLowerCase().replace(/^[\[\(]|[\)\]]$/g, "");
    if (TENBOU_MAP[tenbouKey]) {
        return [{
            type: "tenbou",
            key: tenbouKey,
            ...TENBOU_MAP[tenbouKey]
        }];
    }

    // Regular expression to match standard notation segments
    // Matches:
    // 1. MPSZ multi-tile patterns: e.g. "123m", "05p", "1122z", "r5m", "5mr", "_123m"
    // 2. Named honor words: "ton", "nan", "shaa", "pei", "haku", "hatsu", "chun"
    // 3. Face-down / back tiles: "?", "x", "X", "back", "0z"
    // 4. Single honor letters in specific cases (E, S, W, N, P, G, R/C, D, F)

    let cursor = 0;
    while (cursor < str.length) {
        // Skip separators inside group
        if (/[\s,|+]+/.test(str[cursor])) {
            cursor++;
            continue;
        }

        // Check for face-down tile (?, x, X, back)
        const backMatch = str.slice(cursor).match(/^(\?|x|X|back|hidden)\b/i);
        if (backMatch) {
            tiles.push({
                type: "tile",
                isBack: true,
                name: "Face-down Tile"
            });
            cursor += backMatch[0].length;
            continue;
        }

        // Check for single named honor
        const nameMatch = str.slice(cursor).match(/^(ton|nan|shaa|pei|haku|hatsu|chun|east|south|west|north|white|green|red)\b/i);
        if (nameMatch) {
            const key = nameMatch[1].toLowerCase();
            if (TILE_MAP[key]) {
                tiles.push({
                    type: "tile",
                    code: key,
                    ...TILE_MAP[key]
                });
            }
            cursor += nameMatch[0].length;
            continue;
        }

        // Check for MPSZ notation: sequence of digits/modifiers followed by suit letter
        // e.g. "123m", "_123m", "5mr", "r5m", "0s", "1-", "1m-"
        const mpszMatch = str.slice(cursor).match(/^([_~<>]?)([0-9r*_\-]+)([mpszMPSZ])/);
        if (mpszMatch) {
            const prefixModifier = mpszMatch[1];
            const digits = mpszMatch[2];
            const suit = mpszMatch[3].toLowerCase();

            // Parse individual digits in this suit block
            let i = 0;
            while (i < digits.length) {
                let isSideways = prefixModifier === "_" || prefixModifier === "~" || prefixModifier === "<" || prefixModifier === ">";
                let isDora = false;

                // Check for modifier prefix on digit
                if (digits[i] === "_" || digits[i] === "-") {
                    isSideways = true;
                    i++;
                    if (i >= digits.length) break;
                }

                // Check for red dora indicator 'r' before number: "r5"
                if (digits[i] === "r" || digits[i] === "R") {
                    isDora = true;
                    i++;
                    if (i >= digits.length) break;
                }

                const num = digits[i];
                i++;

                // Check for red dora indicator 'r' or '*' after number: "5r", "5*"
                if (i < digits.length && (digits[i] === "r" || digits[i] === "R" || digits[i] === "*")) {
                    isDora = true;
                    i++;
                }

                // Check for sideways modifier '-' or '_' after number
                if (i < digits.length && (digits[i] === "-" || digits[i] === "_")) {
                    isSideways = true;
                    i++;
                }

                if (num === "0" && (suit === "m" || suit === "p" || suit === "s")) {
                    isDora = true;
                }

                if (suit === "z" && (num === "0" || num === "?")) {
                    tiles.push({
                        type: "tile",
                        isBack: true,
                        isSideways,
                        name: "Face-down Tile"
                    });
                    continue;
                }

                let key = isDora ? `0${suit}` : `${num}${suit}`;
                const tileInfo = TILE_MAP[key] || TILE_MAP[`${num}${suit}`];

                if (tileInfo) {
                    tiles.push({
                        type: "tile",
                        code: `${num}${suit}${isDora ? " (Dora)" : ""}`,
                        isSideways,
                        isDora,
                        ...tileInfo
                    });
                }
            }

            cursor += mpszMatch[0].length;
            continue;
        }

        // Check for single letter honor shortcuts when written alone or capitalized (E, S, W, N, D, G, R, C, F, P)
        const singleHonorMatch = str.slice(cursor).match(/^([ESWNDGRCFP])\b/);
        if (singleHonorMatch) {
            const letter = singleHonorMatch[1];
            const letterMap = {
                E: "1z",
                S: "2z",
                W: "3z",
                N: "4z",
                D: "5z",
                P: "5z",
                G: "6z",
                F: "6z",
                R: "7z",
                C: "7z"
            };
            const code = letterMap[letter];
            if (code && TILE_MAP[code]) {
                tiles.push({
                    type: "tile",
                    code,
                    ...TILE_MAP[code]
                });
            }
            cursor += 1;
            continue;
        }

        // Advance past unparsed character
        cursor++;
    }

    return tiles;
}

/**
 * Parse full mahjong notation into groups
 * e.g. "123m 456p 789s 11z 1m" -> 5 groups
 */
export function parseMahjongNotation(notation) {
    if (!notation || typeof notation !== "string") return [];

    // Split by brackets, commas, or spaces into groups
    // If enclosed in brackets like [123m][456p] or space separated "123m 456p 789s 11z 1m"
    const cleaned = notation.trim();
    const groupTokens = [];

    // Check bracketed groups first: [123m] [456p] ...
    const bracketMatches = cleaned.match(/\[([^\]]+)\]/g);
    if (bracketMatches && bracketMatches.length > 0 && bracketMatches.join("").length >= cleaned.replace(/\s+/g, "").length) {
        bracketMatches.forEach((b) => {
            groupTokens.push(b.replace(/^\[|\]$/g, "").trim());
        });
    } else {
        // Split by whitespace or separator (maintaining separated groups)
        const parts = cleaned.split(/(?:\s{1,}|\s*[,|]\s*|\s*\+\s*)/);
        parts.forEach((p) => {
            if (p.trim()) groupTokens.push(p.trim());
        });
    }

    const groups = [];
    groupTokens.forEach((token) => {
        const tiles = parseTileGroup(token);
        if (tiles.length > 0) {
            groups.push(tiles);
        }
    });

    return groups;
}

/**
 * Size preset mappings for Mahjong hands
 */
const SIZE_PRESETS = {
    "xxs": "14px",
    "xs": "18px",
    "tiny": "18px",
    "sm": "24px",
    "small": "24px",
    "md": "30px",
    "medium": "30px",
    "default": "30px",
    "lg": "42px",
    "large": "42px",
    "xl": "54px",
    "xlarge": "54px",
    "huge": "54px",
    "2xl": "68px",
    "xxl": "68px"
};

/**
 * Convert arbitrary size inputs (preset name, numeric px, css unit) to CSS width string
 */
export function parseSizeToWidth(sizeVal) {
    if (!sizeVal) return "";
    const s = String(sizeVal).trim().toLowerCase();

    if (SIZE_PRESETS[s]) {
        return SIZE_PRESETS[s];
    }

    // e.g. "size-lg" -> "lg", "is-small" -> "small"
    const cleaned = s.replace(/^(?:size-|is-)/, "");
    if (SIZE_PRESETS[cleaned]) {
        return SIZE_PRESETS[cleaned];
    }

    // Pure number like "30" or "45.5" -> "30px"
    if (/^\d+(\.\d+)?$/.test(s)) {
        return `${s}px`;
    }

    // Explicit CSS units: 30px, 2rem, 1.5em, 5vw, etc.
    if (/^\d+(\.\d+)?(px|rem|em|vw|vmin|vmax|%)$/.test(s)) {
        return s;
    }

    return "";
}

/**
 * Extract size, options, and clean notation from shortcode or code content
 */
export function parseShortcodeContent(rawText, prefixOption = "") {
    let notation = (rawText || "").trim();
    let size = prefixOption ? parseSizeToWidth(prefixOption) : "";
    let isBordered = false;

    // Check for inline size or bordered directives:
    // e.g. "123m | size=40px", "123m size:40px", "123m size=lg", "[size: 40px] 123m", "123m bordered"

    // Check for bordered keyword
    if (/\b(?:bordered|border)\b/i.test(notation)) {
        isBordered = true;
        notation = notation.replace(/\b(?:bordered|border)\b/gi, "").trim();
    }

    // Check prefix options like "size=40px" or "40px" or "lg"
    if (prefixOption) {
        const optMatch = prefixOption.match(/(?:size[=:]\s*|width[=:]\s*)?([a-z0-9._%]+)/i);
        if (optMatch) {
            const parsed = parseSizeToWidth(optMatch[1]);
            if (parsed) size = parsed;
        }
    }

    // Check directives inside notation string: [size: 40px] or size=40px or | 40px or | size=lg
    const directiveMatch = notation.match(/(?:^|[|;\s])(?:\[?\s*size[=:]\s*([a-z0-9._%]+)\s*\]?|size=([a-z0-9._%]+)|\|\s*([a-z0-9._%]+))/i);
    if (directiveMatch) {
        const matchedSize = directiveMatch[1] || directiveMatch[2] || directiveMatch[3];
        const parsed = parseSizeToWidth(matchedSize);
        if (parsed) {
            size = parsed;
            notation = notation.replace(directiveMatch[0], " ").trim();
        }
    }

    // Clean up residual separators or brackets
    notation = notation.replace(/^[|;,\s]+|[|;,\s]+$/g, "").trim();

    return {
        notation,
        size,
        bordered: isBordered
    };
}

/**
 * Render parsed groups to an HTML element
 */
export function renderMahjongHtml(groups, options = {}) {
    const isInline = options.isInline || false;
    const isBordered = options.bordered || false;
    const tileWidth = options.tileWidth || "";
    const extraClass = options.className || "";

    const basePath = options.basePath || getTilesBasePath(isBordered);
    const tenbouPath = options.tenbouPath || getTenbouBasePath();

    const hand = document.createElement(isInline ? "span" : "div");
    hand.className = `mahjong-hand${isInline ? " is-inline" : ""}${extraClass ? ` ${extraClass}` : ""}`;
    if (tileWidth) {
        hand.style.setProperty("--mahjong-tile-width", tileWidth);
        hand.style.setProperty("--tile-width", tileWidth);
    }

    groups.forEach((group) => {
        const groupEl = document.createElement(isInline ? "span" : "div");
        groupEl.className = "mahjong-group";

        group.forEach((item) => {
            if (item.type === "tenbou") {
                const tenbouEl = document.createElement("span");
                tenbouEl.className = "mahjong-tenbou";
                tenbouEl.title = item.name;
                const img = document.createElement("img");
                img.src = `${tenbouPath}${item.file}`;
                img.alt = item.name;
                img.loading = "lazy";
                tenbouEl.appendChild(img);
                groupEl.appendChild(tenbouEl);
                return;
            }

            const tileEl = document.createElement(isInline ? "span" : "div");
            tileEl.className = `mahjong-tile${item.isSideways ? " is-sideways" : ""}${item.isBack ? " is-back" : ""}`;
            tileEl.setAttribute("data-tile", item.code || (item.isBack ? "back" : "tile"));
            tileEl.title = item.name || "Mahjong Tile";

            const faceEl = document.createElement(isInline ? "span" : "div");
            faceEl.className = `mahjong-tile-face${item.isBack ? " mahjong-tile-back" : ""}`;

            if (!item.isBack && item.file) {
                const artImg = document.createElement("img");
                artImg.className = "mahjong-tile-art";
                artImg.src = `${basePath}${item.file}`;
                artImg.alt = item.name || item.code || "Tile";
                artImg.loading = "lazy";
                faceEl.appendChild(artImg);
            }

            tileEl.appendChild(faceEl);
            groupEl.appendChild(tileEl);
        });

        hand.appendChild(groupEl);
    });

    return hand;
}

/**
 * Scan DOM and render mahjong notations across post/page content
 */
export default function initMahjongRenderer(options = {}) {
    const container = options.container || document;

    // 1. Convert code blocks with language-mahjong / language-riichi / language-tiles / language-mj
    const codeBlocks = container.querySelectorAll("pre > code");
    codeBlocks.forEach((codeEl) => {
        const pre = codeEl.parentElement;
        if (!pre || pre.dataset.mahjongRendered) return;

        const cls = (codeEl.className || "") + " " + (pre.className || "");
        const match = cls.match(/\b(?:language|lang)-(mahjong|riichi|tiles|mj)\b/i);
        if (match) {
            pre.dataset.mahjongRendered = "true";
            const rawContent = codeEl.textContent || "";

            // Extract options from classes or content
            let size = pre.getAttribute("size") || pre.getAttribute("data-size") || codeEl.getAttribute("data-size") || "";
            if (!size) {
                // Check class names like size-lg, size-40px, is-small
                const sizeClsMatch = cls.match(/\b(?:size|is)-([a-z0-9._%]+)\b/i);
                if (sizeClsMatch) {
                    size = sizeClsMatch[1];
                }
            }

            const parsed = parseShortcodeContent(rawContent, size);
            const isBordered = pre.classList.contains("bordered") || codeEl.classList.contains("bordered") || parsed.bordered;
            const groups = parseMahjongNotation(parsed.notation);

            if (groups.length > 0) {
                const tileWidth = parseSizeToWidth(parsed.size || size);
                const rendered = renderMahjongHtml(groups, {
                    bordered: isBordered,
                    tileWidth: tileWidth
                });
                const wrapper = document.createElement("div");
                wrapper.className = "mahjong-hand-wrapper";
                wrapper.appendChild(rendered);
                pre.parentNode.replaceChild(wrapper, pre);
            }
        }
    });

    // 2. Inline <code> elements outside <pre>: `[mahjong: 123m]` or `<code class="language-mahjong">123m</code>`
    const inlineCodes = container.querySelectorAll(":not(pre) > code");
    inlineCodes.forEach((codeEl) => {
        if (codeEl.dataset.mahjongRendered) return;
        const text = (codeEl.textContent || "").trim();
        const cls = codeEl.className || "";

        const langMatch = cls.match(/\b(?:language|lang)-(mahjong|riichi|tiles|mj)\b/i);
        const shortcodeMatch = text.match(/^\[(?:mahjong|riichi|tiles|mj)(?:-([a-z0-9]+))?(?:\s+([^:\]]+))?:\s*([\s\S]+)\]$/i)
            || text.match(/^\{\{(?:mahjong|riichi|tiles|mj)(?:-([a-z0-9]+))?(?:\s+([\s\S]+))?\}\}$/i);

        if (langMatch || shortcodeMatch || codeEl.hasAttribute("data-mahjong") || codeEl.hasAttribute("data-hand")) {
            codeEl.dataset.mahjongRendered = "true";
            let size = codeEl.getAttribute("size") || codeEl.getAttribute("data-size") || codeEl.getAttribute("data-tile-width") || "";
            let isBordered = codeEl.classList.contains("bordered") || codeEl.hasAttribute("bordered");
            let notation = "";

            if (shortcodeMatch) {
                const sizePrefix = shortcodeMatch[1] || shortcodeMatch[2] || "";
                const rawNotation = shortcodeMatch[3] || shortcodeMatch[2] || "";
                const parsed = parseShortcodeContent(rawNotation, sizePrefix);
                notation = parsed.notation;
                if (parsed.size) size = parsed.size;
                if (parsed.bordered) isBordered = true;
            } else if (langMatch) {
                const parsed = parseShortcodeContent(text, size);
                notation = parsed.notation;
                if (parsed.size) size = parsed.size;
                if (parsed.bordered) isBordered = true;
            } else {
                notation = codeEl.getAttribute("data-mahjong") || codeEl.getAttribute("data-hand") || text;
            }

            const groups = parseMahjongNotation(notation);
            if (groups.length > 0) {
                const tileWidth = parseSizeToWidth(size);
                const rendered = renderMahjongHtml(groups, {
                    isInline: true,
                    bordered: isBordered,
                    tileWidth: tileWidth
                });
                if (codeEl.parentNode) {
                    codeEl.parentNode.replaceChild(rendered, codeEl);
                }
            }
        }
    });

    // 3. Custom HTML elements: <mahjong>, <riichi>, <tiles>, elements with .mahjong-hand / [data-mahjong]
    const customElements = container.querySelectorAll("mahjong, riichi, tiles, mj, .mahjong-hand:not([data-mahjong-rendered]), [data-mahjong]:not([data-mahjong-rendered]), [data-hand]:not([data-mahjong-rendered])");
    customElements.forEach((el) => {
        if (el.dataset.mahjongRendered) return;
        // If it already has children with .mahjong-tile, don't overwrite
        if (el.querySelector(".mahjong-tile")) {
            el.dataset.mahjongRendered = "true";
            return;
        }

        const rawContent = el.getAttribute("data-mahjong") || el.getAttribute("data-hand") || el.textContent || "";
        if (!rawContent.trim()) return;

        el.dataset.mahjongRendered = "true";

        const isSpanOrInline = el.tagName.toLowerCase() === "span" || el.classList.contains("is-inline") || el.hasAttribute("inline") || el.dataset.inline === "true";
        const isBlock = el.classList.contains("is-block") || el.hasAttribute("block") || el.dataset.block === "true";

        // Auto-detect inline if inside a paragraph/list/heading/table cell and not explicitly block
        const parentTag = el.parentElement ? el.parentElement.tagName.toLowerCase() : "";
        const isInsideInlineContext = ["p", "li", "span", "a", "td", "th", "h1", "h2", "h3", "h4", "h5", "h6", "label"].includes(parentTag);
        const isInline = isBlock ? false : (isSpanOrInline || isInsideInlineContext);

        const isBordered = el.classList.contains("bordered") || el.hasAttribute("bordered") || el.dataset.bordered === "true";
        let size = el.getAttribute("size") || el.getAttribute("width") || el.getAttribute("tile-width") || el.getAttribute("data-size") || el.getAttribute("data-tile-width") || el.style.getPropertyValue("--mahjong-tile-width") || "";

        if (!size) {
            const sizeClsMatch = (el.className || "").match(/\b(?:size|is)-([a-z0-9._%]+)\b/i);
            if (sizeClsMatch) {
                size = sizeClsMatch[1];
            }
        }

        const parsed = parseShortcodeContent(rawContent, size);
        const tileWidth = parseSizeToWidth(parsed.size || size);
        const groups = parseMahjongNotation(parsed.notation);

        if (groups.length > 0) {
            const rendered = renderMahjongHtml(groups, {
                isInline,
                bordered: isBordered || parsed.bordered,
                tileWidth,
                className: el.className.replace(/\bmahjong-hand\b/g, "").trim()
            });

            const tag = el.tagName.toLowerCase();
            if (["mahjong", "riichi", "tiles", "mj"].includes(tag)) {
                if (el.parentNode) {
                    el.parentNode.replaceChild(rendered, el);
                }
            } else {
                el.innerHTML = "";
                while (rendered.firstChild) {
                    el.appendChild(rendered.firstChild);
                }
                el.className = rendered.className;
                if (tileWidth) {
                    el.style.setProperty("--mahjong-tile-width", tileWidth);
                    el.style.setProperty("--tile-width", tileWidth);
                }
            }
        }
    });

    // 4. Inline shortcodes in text nodes: [mahjong: ...], [riichi: ...], [tiles: ...], {{mahjong ...}}
    const contentArea = container.querySelector(".gh-content, .gh-article, main, body") || container;
    replaceTextShortcodes(contentArea);
}

/**
 * Replace text shortcodes like [mahjong: 123m456p] in paragraph and list text nodes
 */
function replaceTextShortcodes(rootEl) {
    if (!rootEl) return;

    // Pattern for shortcodes: [mahjong: 123m456p] or [mahjong-lg: 123m] or [riichi size=40px: 123m] or {{mahjong 123m}}
    const shortcodeRegex = /(?:\[(mahjong|riichi|tiles|mj)(?:-([a-z0-9]+))?(?:\s+([^:\]]+))?:\s*([^\]]+)\]|\{\{(mahjong|riichi|tiles|mj)(?:-([a-z0-9]+))?(?:\s+([^}]+))?\}\})/gi;

    const walker = document.createTreeWalker(
        rootEl,
        NodeFilter.SHOW_TEXT,
        {
            acceptNode(node) {
                if (!node.nodeValue || !shortcodeRegex.test(node.nodeValue)) {
                    shortcodeRegex.lastIndex = 0;
                    return NodeFilter.FILTER_SKIP;
                }
                // Avoid rewriting inside script, style, textarea, pre, input
                const parentTag = node.parentElement ? node.parentElement.tagName.toLowerCase() : "";
                if (["script", "style", "textarea", "pre", "input", "select", "svg"].includes(parentTag)) {
                    return NodeFilter.FILTER_REJECT;
                }
                return NodeFilter.FILTER_ACCEPT;
            }
        }
    );

    const nodesToReplace = [];
    while (walker.nextNode()) {
        nodesToReplace.push(walker.currentNode);
    }

    nodesToReplace.forEach((node) => {
        const text = node.nodeValue;
        shortcodeRegex.lastIndex = 0;
        let match;
        let lastIdx = 0;
        const fragment = document.createDocumentFragment();

        while ((match = shortcodeRegex.exec(text)) !== null) {
            const before = text.substring(lastIdx, match.index);
            if (before) {
                fragment.appendChild(document.createTextNode(before));
            }

            const sizePrefix = match[2] || match[3] || match[6] || "";
            const rawNotation = match[4] || match[7] || "";
            const parsed = parseShortcodeContent(rawNotation, sizePrefix);

            const groups = parseMahjongNotation(parsed.notation);
            if (groups.length > 0) {
                const tileWidth = parseSizeToWidth(parsed.size);
                const rendered = renderMahjongHtml(groups, {
                    isInline: true,
                    bordered: parsed.bordered,
                    tileWidth: tileWidth
                });
                fragment.appendChild(rendered);
            } else {
                fragment.appendChild(document.createTextNode(match[0]));
            }

            lastIdx = shortcodeRegex.lastIndex;
        }

        const remaining = text.substring(lastIdx);
        if (remaining) {
            fragment.appendChild(document.createTextNode(remaining));
        }

        if (node.parentNode) {
            node.parentNode.replaceChild(fragment, node);
        }
    });
}
